import { Converter } from "../../interface/converter.interface";

	/**
	 * @description
	 *	Permite transformar un objeto 'Date' en una representación 'string'
	 *	simplificada que solo contiene la fecha en formato ISO, esto es, una
	 *	cadena de la forma 'yyyy-mm-dd'.
	 */

export class DateToStringConverter implements Converter<Date, string> {

	constructor() {}

	public preConvert(value: Date): string {
		return value.toISOString();
	}

	public postConvert(value: Date): string {
		return value.toISOString().replace(/T.*/, "");
	}
}
